import React from 'react'

export default props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833496 9.99967C0.833496 15.0623 4.93755 19.1663 10.0002 19.1663C15.0628 19.1663 19.1668 15.0623 19.1668 9.99967C19.1668 4.93706 15.0628 0.833008 10.0002 0.833008C4.93755 0.833008 0.833496 4.93706 0.833496 9.99967ZM17.5002 9.99967C17.5002 14.1418 14.1423 17.4997 10.0002 17.4997C5.85803 17.4997 2.50016 14.1418 2.50016 9.99967C2.50016 5.85754 5.85803 2.49967 10.0002 2.49967C14.1423 2.49967 17.5002 5.85754 17.5002 9.99967ZM10.8365 11.665H11.6693V13.3316H8.33596V11.665H9.16929V9.9983H8.33596V8.33163H10.8365V11.665ZM10.834 6.66496C10.834 7.1252 10.4608 7.4983 10.0004 7.4983C9.54005 7.4983 9.16683 7.1252 9.16683 6.66496C9.16683 6.20473 9.54005 5.83163 10.0004 5.83163C10.4608 5.83163 10.834 6.20473 10.834 6.66496Z"
      fill="#707087"
    />
  </svg>
)
